/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBusinessRuleFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeBusinessRule, serializeBusinessRuleUpdateRequest, serializeCustomBusinessRuleCreateRequest, type BusinessRule, type BusinessRuleUpdateRequest, type CustomBusinessRuleCreateRequest, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { BusinessRuleItemRequestBuilderRequestsMetadata, type BusinessRuleItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { TestRequestBuilderRequestsMetadata, type TestRequestBuilder } from './test/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /BusinessRule
 */
export interface BusinessRuleRequestBuilder extends BaseRequestBuilder<BusinessRuleRequestBuilder> {
    /**
     * The Test property
     */
    get test(): TestRequestBuilder;
    /**
     * Gets an item from the ApiSdk.BusinessRule.item collection
     * @param id Unique identifier of the item
     * @returns {BusinessRuleItemRequestBuilder}
     */
     byId(id: number) : BusinessRuleItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     delete(requestConfiguration?: RequestConfiguration<BusinessRuleRequestBuilderDeleteQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BusinessRule[]>}
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BusinessRule[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BusinessRule>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     post(body: CustomBusinessRuleCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BusinessRule | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: BusinessRuleUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<BusinessRuleRequestBuilderDeleteQueryParameters> | undefined) : RequestInformation;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CustomBusinessRuleCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: BusinessRuleUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface BusinessRuleRequestBuilderDeleteQueryParameters {
    id?: number;
}
/**
 * Uri template for the request builder.
 */
export const BusinessRuleRequestBuilderUriTemplate = "{+baseurl}/BusinessRule";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const BusinessRuleRequestBuilderNavigationMetadata: Record<Exclude<keyof BusinessRuleRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: BusinessRuleItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
    test: {
        requestsMetadata: TestRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const BusinessRuleRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: "{+baseurl}/BusinessRule?id={id}",
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
    },
    get: {
        uriTemplate: BusinessRuleRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createBusinessRuleFromDiscriminatorValue,
    },
    post: {
        uriTemplate: BusinessRuleRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBusinessRuleFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCustomBusinessRuleCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: BusinessRuleRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeBusinessRuleUpdateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
